import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year6/Summer/PositionAndDirection/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PositionAndDirection',
  field: 'Geometry',
  weeks: [4, 4],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Summer/PositionAndDirection/1TheFirstQuadrant" */ './1TheFirstQuadrant'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Summer/PositionAndDirection/2ReadAndPlotPointsInFourQuadrants" */ './2ReadAndPlotPointsInFourQuadrants'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Summer/PositionAndDirection/3SolveProblemsWithCoordinates" */ './3SolveProblemsWithCoordinates'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Summer/PositionAndDirection/4Translations" */ './4Translations'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Summer/PositionAndDirection/5Reflections" */ './5Reflections'
        )
    })
  ]
});
export default Block;
